




























































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators'
import { getFieldError } from '@/core/tools/forms/get_field_error';

import { STORE_KEY, store } from './_store';
import AheadCombobox from '@/components/Controls/AheadCombobox.vue';

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      'loading', 'loaded', 'fatalError',

      'document', 'meta'
    ]),
  },
  methods: {
    getFieldError
  },
  components: {
    AheadCombobox
  },
  validations() {
    const rules: any = {
      close_state: { required },
      close_reasone: { },
      close_reasone_line_1_id: { },
      close_reasone_line_2_id: { },
      close_description: { },
    }

    return {
      form: rules
    }
  }
})
export default class ShiftClose extends Vue {

  selectedView: string = 'normal'
  warehouse_id: number|null = null

  form: any = {
    close_state: 'normal',
    close_reasone_line_1_id: null,
    close_reasone_line_2_id: null,
  }

  setParams(field: string, $event: any) {
    console.log($event);
    this.form[field] = $event;
  }

  saveFormData() {
    this.$v.form.$touch()

    if(!this.$v.form.$error) {
      this.$store.dispatch(`${STORE_KEY}/stopShift`, {form: this.form, warehouse_id: this.warehouse_id}).then(() => {
          this.$buefy.snackbar.open(`Смена успешно закрыта`);
          //@ts-ignore
          this.$parent.close()
      }).catch((message: string) => {
        this.$buefy.snackbar.open({
          type: 'is-danger',
          message: message ? message : `При сохранении возникли проблемы. Попробуйте позже.`
        })
        //@ts-ignore
        this.$parent.close()
      });
    }

  }
}
